import React, { useState, useEffect, useRef } from "react";
import BootstrapSwitchButton from "bootstrap-switch-button-react";
import { Row, Col } from "react-bootstrap";
import "./SingleLoan.css";
import { useForm, FormProvider } from "react-hook-form";
import Inputmask from "inputmask";
import { commonService, toasterService } from "../../services";
import { FormField } from "../../components/FormField/FormField";
import { OutputReports } from "../OutputReports/OutputReports";

export function SingleLoan() {
  const [elements, setElements] = useState(null);
  const [selectedOption, setSelectedOption] = useState(true);
  const [loading, showLoader] = useState(false);
  const [formSuccess, setFormSuccess] = useState(false);
  const [reportSuccess, setReportSuccess] = useState(false);
  const [outputData, setOutputData] = useState(null);

  const methods = useForm();
  const toaster = useRef(null);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = methods;

  const fields = elements ?? [];

  const onSubmit = (data) => {
    if (toaster) {
      toasterService.dismiss(toaster.current);
    }
    if (!selectedOption) {
      commonService
        .submitPriceLoanForm(data)
        .then((data) => {
          setFormSuccess(true);
          getOutputReport(data.data.data, 0);
          window.scrollTo({ top: 0, behavior: "smooth" });
        })
        .catch((error) => {
          toaster.current = toasterService.error(error.response.data.message, {
            hideProgressBar: true,
            autoClose: false,
          });
        });
    } else {
      commonService
        .submitInterestLoanForm(data)
        .then((data) => {
          setFormSuccess(true);
          getOutputReport(data.data.data, 1);
          window.scrollTo({ top: 0, behavior: "smooth" });
        })
        .catch((error) => {
          toaster.current = toasterService.error(error.response.data.message, {
            hideProgressBar: true,
            autoClose: false,
          });
        });
    }
  };

  useEffect(() => {
    // Update the document title using the browser API
    // console.log("Currency Component loaded");
    getFormFields(true);
    setFormSuccess(false);
    setReportSuccess(false);
    // getOutputReport('test_interest_rate68', 1);
    // console.log(selectedOption);
    //
  }, []);

  function getOutputReport(filename, type) {
    commonService
      .generateReport({ file: filename, type: type })
      .then((data) => {
        setOutputData(data.data);
        setFormSuccess((formSuccess) => (formSuccess = false));
        setReportSuccess((reportSuccess) => (reportSuccess = true));
      })
      .catch((error) => {
        toasterService.error(error.response.data.message, {
          hideProgressBar: true,
          autoClose: false,
        });
        setFormSuccess((formSuccess) => (formSuccess = false));
      });
  }

  function getFormFields(value) {
    if (value) {
      // Call I form data
      showLoader(true);
      commonService
        .getFormFields("I")
        .then((data) => {
          setElements(data.data);
          setSelectedOption((selectedOption) => (selectedOption = true));
          Inputmask().mask(document.querySelectorAll("input"));
          showLoader((loading) => (loading = false));
        })
        .catch((error) => {
          toasterService.error(error.response.data.message);
        });
    } else {
      // Call P form data
      showLoader(true);
      commonService
        .getFormFields("P")
        .then((data) => {
          setElements(data.data);
          setSelectedOption((selectedOption) => (selectedOption = false));
          Inputmask().mask(document.querySelectorAll("input"));
          showLoader((loading) => (loading = false));
        })
        .catch((error) => {
          toasterService.error(error.response.data.message);
        });
    }
  }

  return (
    <div>
      <div className="mb-3">
        <h4>Price Single Loan</h4>
        {/* <p className="text-muted">Please fill the form for single loan report</p> */}
      </div>
      <div className="form-container">
        {formSuccess && !reportSuccess && (
          <div className="form-success">
            {/* <FontAwesomeIcon className="text-success fa-4x mb-3" icon={faCheckCircle} /> */}
            <h4 className="display-6 text-center">
              Processing. Please don't close this window. Can take up to 2
              minutes.
            </h4>
            <div className="progress mt-4">
              <div
                className="progress-bar-fb"
                style={{ background: "#337ab7" }}
              ></div>
            </div>
          </div>
        )}
        {!formSuccess && reportSuccess && (
          <>
            <h4>
              <a
                className="text-primary text-decoration-none"
                href="javascript:;"
                onClick={() => {
                  setFormSuccess(false);
                  setReportSuccess(false);
                }}
              >
                <i className="bi bi-arrow-left-circle"></i> Go back / Reprice Loan
              </a>
            </h4>
            <h3>
              <br /><br />Ready to submit?{" "}
              <a href="https://buttonfinance.encompasstpoconnect.com/#/content/login" target="_blank">Click here</a>
              <br />
              <br />
              Rate includes an additional 0.375% discount on 3-yr Draw HELOCs.
              <br />
              Correspondents will receive an additional 0.50% purchase premium on 3-yr Draw HELOCs, instead of the discount.
              <br />
              <br />
            </h3>


            <OutputReports outputData={outputData} />
          </>
        )}

        <div hidden={formSuccess || reportSuccess}>
          <div className="mb-3">
            <label className="me-2">Select an option</label>
            <BootstrapSwitchButton
              checked={selectedOption}
              onlabel="Calculate Interest Rate"
              offlabel="Price Loan"
              onChange={(val) => {
                getFormFields(val);
              }}
              offstyle="primary"
            />
          </div>
          <hr />
          <FormProvider {...methods}>
            <form onSubmit={handleSubmit(onSubmit)}>
              {loading && (
                <div key="loader" className="d-flex justify-content-center">
                  <div className="spinner-border" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              )}
              {!loading && fields.length > 0 && (
                <div>
                  <Row>
                    {fields.map((field, i) => {
                      return (
                        <Col key={i} xs={12} md={12 / 2}>
                          <FormField key={i} field={field} />
                        </Col>
                      );
                    })}
                  </Row>
                </div>
              )}

              <input
                className="btn btn-primary"
                type="submit"
                variant="primary"
                value="Submit"
              />
            </form>
          </FormProvider>
        </div>
      </div>
    </div>
  );
}
